import classNames from "classnames";
import moment from "moment";
import React from "react";
import { newAppointment } from "../../utilities/coordinatorUtils";
import ItineraryAppointmentRow from "./ItineraryAppointmentRow";
import { getId } from "./utils";

interface Props {
  showId: number
  artist: server.dto.ArtistSmall
  dayAppointments: server.dto.PlannerDay

  linkedFlightSegmentIds: number[]
  linkedGroundTransportIds: number[]
  linkedTrainSegmentIds: number[]

  toggleLinked: (appointment: server.dto.PlannerAppointment) => void

  onHoveringOver: (appointment: server.dto.PlannerAppointment) => void
  hoveringOver: server.dto.PlannerAppointment
  canCreateNewAppointment: boolean
  canLinkUnlinkTravel: boolean
}

const ItineraryDay = (props: Props) => {
  const hasAppointments = props.dayAppointments.appointments.length > 0;
  const dayRowSpan = hasAppointments ? props.dayAppointments.appointments.length : 1;

  const trClasses = classNames({
    noappointments: !hasAppointments
  });

  const appointmentMoment = moment.utc(props.dayAppointments.date);

  const onDayClicked = () => {
    if (!props.canCreateNewAppointment) {
      return;
    }

    newAppointment({
      date: appointmentMoment.toISOString(),
      artist: props.artist,
      fromItem: {
        type: "show",
        id: props.showId
      }
    });
  };

  const dayTdStyle: React.CSSProperties = props.canCreateNewAppointment
    ? undefined
    : {
      cursor: "default"
    };

  const firstAppointment = props.dayAppointments.appointments[0];

  return <>
    <tr className={trClasses}>
      <td className="day" style={dayTdStyle} rowSpan={dayRowSpan} onClick={onDayClicked}>
        {appointmentMoment.format("ddd")} {appointmentMoment.toDate().getUTCDate()}
        <br />
        {appointmentMoment.format("MMM")}
      </td>
      {!hasAppointments && <td colSpan={10}></td>}
      {hasAppointments &&
        <ItineraryAppointmentRow
          onHoverOver={props.onHoveringOver}
          hoveringOver={props.hoveringOver}
          appointment={firstAppointment}
          linkedFlightSegmentIds={props.linkedFlightSegmentIds}
          linkedGroundTransportIds={props.linkedGroundTransportIds}
          linkedTrainSegmentIds={props.linkedTrainSegmentIds}
          toggleLinked={props.toggleLinked}
          showId={props.showId}
          canCreateNewAppointment={props.canCreateNewAppointment}
          canLinkUnlinkTravel={props.canLinkUnlinkTravel}
        />}
    </tr>
    {props.dayAppointments.appointments.slice(1).map(app => (
      <tr key={getId(app)}>
        <ItineraryAppointmentRow
          onHoverOver={props.onHoveringOver}
          hoveringOver={props.hoveringOver}
          appointment={app}
          linkedFlightSegmentIds={props.linkedFlightSegmentIds}
          linkedGroundTransportIds={props.linkedGroundTransportIds}
          linkedTrainSegmentIds={props.linkedTrainSegmentIds}
          toggleLinked={props.toggleLinked}
          showId={props.showId}
          canCreateNewAppointment={props.canCreateNewAppointment}
          canLinkUnlinkTravel={props.canLinkUnlinkTravel}
        />
      </tr>
    ))}
  </>;
};

export default ItineraryDay;